import moment from 'moment';
import { AuditLogHistoryEntryModal } from '../../auditing/audit-log-entry-history-modal.component';
import { convertTo12hTime } from './time-entry-modifications-util';
/**
 * A component that displays a list of time entries on the current user's time card
 * that were edited by another user and are in need of acknowledgement.
 */
export const DashboardModifiedTimeEntriesContainerComponent = {
    template: `
        <apex-dashboard-modified-time-entries ng-if="$ctrl.loaded && $ctrl.modifiedTimeEntries.length"
                                              modified-time-entries="$ctrl.modifiedTimeEntries"
                                              on-acknowledge="$ctrl.onAcknowledge($event)"
                                              on-show-details="$ctrl.onShowDetails($event)"
                                              on-acknowledge-all="$ctrl.onAcknowledgeAll($event)">
        </apex-dashboard-modified-time-entries>`,
    require: {
        dashboardContext: "^apexDashboardContent"
    },
    controller: class DashboardModifiedTimeEntriesContainer {
        constructor($q, $uibModal, timeEntryComplianceService, utilityService) {
            'ngInject'
            this.$q = $q
            this.timeEntryComplianceService = timeEntryComplianceService
            this.utilityService = utilityService
            this.loaded = false
            this.$uibModal = $uibModal
        }

        $onInit() {
            this.timeEntryComplianceService.retrieveModifiedTimeEntries()
                .then(timeEntries => {
                    convertTo12hTime(timeEntries);
                    this.modifiedTimeEntries = timeEntries;
                    this.loaded = true;

                    if (this.dashboardContext) {
                        this.dashboardContext.activateDashboard({
                            visible: timeEntries.length > 0,
                            count: timeEntries.length
                        });
                    }
                })
        }

        onAcknowledge({ modification }) {
            modification.IsAcknowledged = true;
            const saved = this.timeEntryComplianceService
                .acknowledgeTimeEntryModification(modification.TimeEntryModificationID);

            this.utilityService.alertOnError(saved, "Could not acknowledge")
        }

        onShowDetails({ modification }) {
            const id = modification.TimeEntryModificationID;
            const loadModification = this.timeEntryComplianceService.retrieveTimeEntryModificationHistory(id)
                .then(timeEntryModificationHistory => {
                    const timeEntryModification = this.mapTimeEntryModification(timeEntryModificationHistory)
                    this.$uibModal.open({
                        ...AuditLogHistoryEntryModal,
                        resolve: {
                            auditLogEntry: () => timeEntryModification,
                            title: () => "Changes to Time Entry"
                        }
                    })
                });
            this.utilityService.alertOnError(loadModification, "Unable to load")
        }

        mapTimeEntryModification(history) {
            const timeEntryModification = {};
            timeEntryModification.History = history.map(q => ({
                ...q,
                OldValueData: q.__moment ? this.formatTimeChange(q.__moment.OldValueData) : q.OldValueData,
                NewValueData: q.__moment ? this.formatTimeChange(q.__moment.NewValueData) : q.NewValueData
            }));
            return timeEntryModification;
        }

        formatTimeChange(momentTime) {
            return moment.parseZone(momentTime)
                .format("hh:mm a Z")
        }

        onAcknowledgeAll() {
            const acknowledgeEach = this.modifiedTimeEntries.filter(p => !p.IsAcknowledged)
                .map(modification => {
                    modification.IsAcknowledged = true
                    return this.timeEntryComplianceService.acknowledgeTimeEntryModification(
                        modification.TimeEntryModificationID
                    ).catch(ex => {
                        modification.IsAcknowledged = false
                        throw ex
                    })
                })
            this.utilityService.showLoadingUntilResolved(this.$q.all(acknowledgeEach))
        }
    }
}

